// AuthGate.tsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "@blueprintjs/core";
import { useAuth } from "./AuthContext";

export default function AuthGate({ children }: { children: React.ReactNode }) {
  const { idToken, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !idToken) {
      navigate("/login");
    }
  }, [loading, idToken, navigate]);

  if (loading || (!idToken && loading)) {
    return (
      <div style={{ textAlign: "center", padding: "4rem" }}>
        <Spinner intent="primary" size={40} />
      </div>
    );
  }

  return <>{children}</>;
}
